import React from 'react';
import {PrivateRoutes} from './private';
import {PublicRoutes} from './public';

export default function AppRoutes() {
  const user = localStorage.getItem('token');

  return user ? <PrivateRoutes /> : <PublicRoutes />;
}
